"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Utils = exports.Typings = exports.Constants = exports.AuthorSchemas = void 0;
Object.defineProperty(exports, "exportUserProgressToExcel", {
  enumerable: true,
  get: function get() {
    return _excel.exportUserProgressToExcel;
  }
});
Object.defineProperty(exports, "processProgressData", {
  enumerable: true,
  get: function get() {
    return _excel.processProgressData;
  }
});
var _excel = require("./excel");
var _course = _interopRequireDefault(require("./models/schemas/course"));
var _customStyle = _interopRequireDefault(require("./models/schemas/customStyle"));
var _documentResource = _interopRequireDefault(require("./models/schemas/documentResource"));
var _dynamicAnnotation = _interopRequireDefault(require("./models/schemas/dynamicAnnotation"));
var _learner = _interopRequireDefault(require("./models/schemas/learner"));
var _moduleProgress = _interopRequireDefault(require("./models/schemas/moduleProgress"));
var _slideProgress = _interopRequireDefault(require("./models/schemas/slideProgress"));
var _slideTimeStamp = _interopRequireDefault(require("./models/schemas/slideTimeStamp"));
var _module = _interopRequireDefault(require("./models/schemas/module"));
var _resource = _interopRequireDefault(require("./models/schemas/resource"));
var _slide = _interopRequireDefault(require("./models/schemas/slide"));
var _statefulResource = _interopRequireDefault(require("./models/schemas/statefulResource"));
var _tag = _interopRequireDefault(require("./models/schemas/tag"));
var _user = _interopRequireDefault(require("./models/schemas/user"));
var Constants = _interopRequireWildcard(require("./constants"));
exports.Constants = Constants;
var Slide = _interopRequireWildcard(require("./utils/slide"));
var Functions = _interopRequireWildcard(require("./utils/functions"));
var UserAgentParser = _interopRequireWildcard(require("./utils/userAgentParser"));
var Captions = _interopRequireWildcard(require("./utils/captions"));
var Typings = _interopRequireWildcard(require("./typings"));
exports.Typings = Typings;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Schemas

// Constants

// Util Functions

var AuthorSchemas = {
  Course: _course["default"],
  CustomStyle: _customStyle["default"],
  DocumentResource: _documentResource["default"],
  DynamicAnnotation: _dynamicAnnotation["default"],
  Learner: _learner["default"],
  ModuleProgress: _moduleProgress["default"],
  SlideProgress: _slideProgress["default"],
  SlideTimeStamp: _slideTimeStamp["default"],
  Module: _module["default"],
  Resource: _resource["default"],
  Slide: _slide["default"],
  StatefulResource: _statefulResource["default"],
  Tag: _tag["default"],
  User: _user["default"]
};
exports.AuthorSchemas = AuthorSchemas;
var Utils = {
  Slide: Slide,
  Functions: Functions,
  UserAgentParser: UserAgentParser,
  Captions: Captions
};
exports.Utils = Utils;